import { State } from '../StateTypes';
import { ScreensaverMode } from './screensaverTypes';
import screensaverModes from './screensaverModes';

/**
 * Select screensaver state slice
 * @param screensaver
 */
export const selectScreensaverMode = ({
  screensaver,
}: State): ScreensaverMode => screensaver.mode;

/**
 * Checks if any screensaver is active
 *
 * @param state
 * @returns {boolean}
 */
export const selectScreensaverIsActive = (state: State): boolean =>
  selectScreensaverMode(state) !== screensaverModes.IDLE;
